/***
 *
 *   TICKET CONTEXT BAND STYLES
 *   `shrink-0` throughout: this band sits outside the conversation's scroll,
 *   so its height is bounded rather than flexible. The description is the one
 *   thing that can overflow, and it scrolls inside its own cap.
 *
 **********/

const Style = {
    band: 'shrink-0 border-b border-border bg-surface/40',

    header: `flex w-full items-center gap-2 px-4 py-2 text-left transition-colors
        hover:bg-muted/40 focus-visible:outline-none focus-visible:ring-2
        focus-visible:ring-ring focus-visible:ring-inset sm:px-6`,
    chevron: 'shrink-0 text-text-muted transition-transform duration-150',
    chevronClosed: '-rotate-90',
    title: 'text-xs font-semibold uppercase tracking-wide text-text-secondary',
    count: `inline-flex items-center gap-1 rounded-full bg-muted px-1.5 py-0.5 text-[10px]
        font-semibold text-text-muted`,
    toggleHint: 'ml-auto text-[11px] text-text-muted',

    body: 'space-y-3 px-4 pb-3 sm:px-6',

    // Capped so a long description cannot squeeze the conversation out; the
    // inner scroll only engages past the cap.
    description: 'max-h-36 overflow-y-auto',
    descriptionText: 'whitespace-pre-wrap break-words text-sm leading-relaxed text-text-secondary',
    descriptionEmpty: 'text-sm italic text-text-muted',

    attachments: 'space-y-2',
};

export default Style;
